import * as React from 'react';

const ChevronRight16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M5.47 2.47a.75.75 0 0 0 0 1.06L9.94 8l-4.47 4.47a.75.75 0 1 0 1.06 1.06l5-5a.75.75 0 0 0 0-1.06l-5-5a.75.75 0 0 0-1.06 0"
  }
));
ChevronRight16.Size = 16;
ChevronRight16.Title = "ChevronRight";

export { ChevronRight16 as default };
